import { ReactNode, Key, ReactElement } from "react";
import Tabs, { Tab, TabPanel } from "@ingka/tabs";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/carousel/dist/style.css";
import "@ingka/tabs/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaTabPanelProps = {
  children?: ReactNode;
  key?: Key;
  tabPanelId: string;
  className?: string;
};

type FixaTabProps = {
  key?: Key;
  tabPanelId: string;
  text?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | boolean;
  className?: string;
  "data-testid"?: string;
};

type FixaTabsProps = {
  className?: string;
  activeTab?: string;
  defaultActiveTab?: string;
  onTabChanged?: (tabId: string) => void;
  tabPanels?: ReactElement<FixaTabPanelProps>[];
  tabs?: ReactElement<FixaTabProps>[];
  "data-testid"?: string;
  overflowCarouselProps?: FixaOverflowCarouselProps;
};

type FixaOverflowCarouselProps = {
  className?: string;
};

export function FixaTab(props: FixaTabProps) {
  return <Tab {...props} />;
}

export function FixaTabPanel(props: FixaTabPanelProps) {
  return <TabPanel {...props} />;
}

function FixaTabs(props: FixaTabsProps) {
  return <Tabs {...props} />;
}

export default FixaTabs;
